module.exports = __webpack_public_path__ + "static/media/jupiterTut.2fa8966b.jpg";